<template>
  <div class="content">
    <div v-show="queryOption.action==='error'">
      error Page
    </div>
  </div>
</template>
<script>
// import { setToken } from '@/utils/storage.js';
export default {
  name: 'Distributor',
  data() {
    return {
      queryOption: {}

    };
  },
  mounted() {
    const params = this.$route.query;
    this.queryOption = params;
    // this.init();
  },
  methods: {
    // init() {
    //   if (this.queryOption.action === 'login') {
    //     this.$router.push({ path: '/login' });
    //   } else if (this.queryOption.action === 'home' && this.queryOption.source === 'school') {
    //     window.location.href = `${window.location.origin}/school#/home/app`;
    //     setToken(this.queryOption.token);
    //   } else {
    //     window.location.href = `${window.location.origin}/manage#/home`;
    //     setToken(this.queryOption.token);
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>

</style>
